/**
 * This is a generic w,h size object.
 */
export class Size {
  constructor (w, h) {
    return this.set(w, h);
  }

  set (w = 0, h = 0) {
    this.w = Number(w);
    this.h = Number(h);
    return this;
  }

  setSize (cs) {
    this.set(cs.w, cs.h);
    return this;
  }

  getArea () {
    return (this.w * this.h);
  }

  add (dw, dh) {
    this.w += Number(dw);
    this.h += Number(dh);
    return this;
  }

  addSize (cs) {
    return this.add(cs.w, cs.h);
  }

  // TODO rename to Subtract
  subt (dw, dh) {
    this.w -= Number(dw);
    this.h -= Number(dh);
    return this;
  }

  mult (dx, dy) {
    this.w = this.w * dx;
    this.h = this.h * dy;
    return this;
  }

  div (dx, dy) {
    this.w = this.w / dx;
    this.h = this.h / dy;
    return this;
  }

  // TODO: This looks out of place... A generic "shape" probably shouldn't know what an Image Server tile is...
  toTileNums (tileW, tileH, zoom) {
    this.w = Math.ceil(this.w / tileW / zoom);
    this.h = Math.ceil(this.h / tileH / zoom);
    return this;
  }

  maxDim () {
    return Math.max(this.w, this.h);
  }

  toInt () {
    this.w = Math.round(this.w);
    this.h = Math.round(this.h);
    return this;
  }

  getCenterW (roundToInt) {
    // note that 0-based counting is assumed by the -1
    return (roundToInt) ? Math.round(this.w / 2 - 1) : this.w / 2 - 1;
  }

  getCenterH (roundToInt) {
    // note that 0-based counting is assumed by the -1
    return (roundToInt) ? Math.round(this.h / 2 - 1) : this.h / 2 - 1;
  }
}



// WEBPACK FOOTER //
// ./src/uScope/js/lib/objects/Size.js